var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "d-flex justify-content-start align-items-center px-2" },
    [
      _c(
        "div",
        {
          staticClass:
            "mt-05 mb-05 d-flex justify-content-between align-items-center font-weight-bold flex-grow-1",
        },
        [
          _c(
            "a",
            {
              staticClass: "ml-05 m-0 text-left text-capitalize",
              attrs: {
                href: "/member/profiles/" + _vm.user.username,
                target: "_blank",
              },
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.user.first_name) +
                  " " +
                  _vm._s(_vm.user.last_name) +
                  "\n            "
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-link text-capitalize",
              attrs: {
                type: "button",
                id: _vm.user.id + "popover-engagement",
                "data-toggle": "popover",
                "data-trigger": "focus",
                "data-html": true,
                "data-content":
                  "Posts Made: " +
                  _vm.user.posts_count +
                  "<br> Questions Asked: " +
                  _vm.user.questions_count +
                  "<br> Likes Given: " +
                  _vm.user.likes_count +
                  "<br> Comments Made: " +
                  _vm.user.comments_count,
                "data-title":
                  _vm.user.first_name +
                  " " +
                  _vm.user.last_name +
                  " " +
                  this.__("globals.engagement"),
              },
            },
            [
              _c("i", {
                staticClass: "feather icon-chevron-down",
                staticStyle: { "font-size": "16px" },
              }),
            ]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }